const isSearchValue = value => {
  return value.length > 3 ? true : Boolean(value.match(/(\d+)/g));
};

export default isSearchValue;
